import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';

import ScrollableAnchor from 'react-scrollable-anchor';
import { configureAnchors } from 'react-scrollable-anchor';

import Breadcrumbs from '../../breadcrumbs';
import {Wrapper} from 'system/wrapper';

import recordDoc from 'images/habitans/recordDoc.png';
import register from 'images/habitans/register.png';
import registerForm from 'images/habitans/registerForm.png';
import recordForm from 'images/habitans/recordForm.png';
import docTitle from 'images/habitans/docTitle.png';
import login from 'images/habitans/login.png';
import recordToView from 'images/habitans/recordToView.png';
import timeToDoc from 'images/habitans/timeToDoc.png';
import confirmRecordToDoc from 'images/habitans/confirmRecordToDoc.png';
import makeRate from 'images/habitans/makeRate.png';
import makeMark from 'images/habitans/makeMark.png';
import beforeSendMark from 'images/habitans/beforeSendMark.png';
import publishedRate from 'images/habitans/publishedRate.png';
import sendThanks from 'images/habitans/sendThanks.png';
import thanksToDoc from 'images/habitans/thanksToDoc.png';
import thanksReview from 'images/habitans/thanksReview.png';
import publishedThanks from 'images/habitans/publishedThanks.png';
import abuse from 'images/habitans/abuse.png';
import abuseToDoc from 'images/habitans/abuseToDoc.png';
import abuseReview from 'images/habitans/abuseReview.png';
import publishedAbuse from 'images/habitans/publishedAbuse.png';

import {InstructionList, MainMenu, InstructionItem, InstructionItemHeader, InstructionItemContent, ButtonToTop} from './components';

configureAnchors({offset: -80, scrollDuration: 400});

const LoginAndRegistration = () => (<div>
	<InstructionItemHeader>
		<div>1</div>
		<h3>Вхід та реєстрація</h3>
	</InstructionItemHeader>
	<p>Доступ до сервісу запису на прийом до лікаря мають лише зареєстровані користувачі порталу. <a href="#section1" style={{color: "#edbd2f"}}>Як зареєструватися?</a>
		<br/>Якщо Ви вже зареєстровані на порталі - увійдіть на портал. Для цього натисніть на кнопку
		<img src={login} alt="логін"></img>
		в головному меню. У формі входу введіть Ваш логін і пароль та натисніть кнопку “Увійти”.</p>
</div>)

const OpenDoctorCard = () => (<div>
	<InstructionItemHeader>
		<div>2</div>
		<h3>Відкрийте картку лікаря</h3>
	</InstructionItemHeader>
	<p>Як відкрити картку лікаря - див. пункт <a href="#section2" style={{color: "#edbd2f"}}>Як знайти мого лікаря?</a></p>
</div>)

class Habitants extends Component {
	render() {
		return (<div>
			<Breadcrumbs>
				<li>
					<Link to="/">Головна</Link>
				</li>
				<li>
					<Link to="/habitants">Мешканцям міста</Link>
				</li>
			</Breadcrumbs>
			<Wrapper>
				<Grid>
					<ScrollableAnchor id={'top'}>
						<h2>Мешканцям міста</h2>
					</ScrollableAnchor>
					<MainMenu>
						<li>
							<a href="#section1">1) Як та навіщо реєструватися на медичному порталі?</a>
						</li>
						<li>
							<a href="#section2">2) Як знайти мого лікаря?</a>
						</li>
						<li>
							<a href="#section3">3) Як записатися на прийом до лікаря?</a>
						</li>
						<li>
							<a href="#section4">4) Як оцінити роботу лікаря?</a>
						</li>
						<li>
							<a href="#section5">5) Як залишити подяку лікарю?</a>
						</li>
						<li>
							<a href="#section6">6) Як залишити скаргу на лікаря?</a>
						</li>
					</MainMenu>

					<InstructionList>
						<InstructionItem>
							<ScrollableAnchor id={'section1'}>
								<h2>1) Як та навіщо реєструватися на медичному порталі?</h2>
							</ScrollableAnchor>
							<h4>Зареєстрований користувач може:</h4>
							<ul>
								<li>1) записатися на прийом до лікаря або посадової особи;</li>
								<li>2) поставити оцінку;</li>
								<li>3) залишити подяку або скаргу.</li>
							</ul>
							<p>Зареєструватися на порталі дуже просто - натисніть на кнопку
								<img src={register} alt="реєстрація"></img>
								в головному меню. Заповніть всі обов’язкові поля у формі реєстрації, а також погодьтеся на обробку
								персональних даних. Натисніть на кнопку “Зареєструватися”, щоб завершити реєстрацію.
							</p>
              <InstructionItemContent>
              	<img src={registerForm} alt="" />
							</InstructionItemContent>
						</InstructionItem>

						<InstructionItem>
							<ScrollableAnchor id={'section2'}>
								<h2>2) Як знайти мого лікаря?</h2>
							</ScrollableAnchor>

							<InstructionItemHeader>
								<div>1</div>
								<h3>Відкрийте форму пошуку лікаря</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<p>Перейдіть до сервісу “Запис до лікаря”.</p>
								<img src={recordDoc} alt="запис до лікаря"></img>
								<p>Відкриється форма пошуку лікаря:</p>
								<img src={recordForm} alt="форма запису до лікаря"></img>
							</InstructionItemContent>
							<InstructionItemHeader>
								<div>2</div>
								<h3>Задайте параметри пошуку</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<h4>Ви можете задати такі параметри пошуку:
								</h4>
								<ul>
									<li>- якщо Вам відомо прізвище або частина прізвища лікаря, введіть його в поле “Пошук за прізвищем лікаря”;</li>
									<li>- якщо Ви хочете знайти лікаря певної спеціалізації - задайте її через фільтр за спеціальностями;</li>
									<li>- якщо Ви шукаєте лікаря певної медичної установи - оберіть її у фільтрі установ.</li>
								</ul>
								<p>Ви можете задавати будь-яку комбінацію параметрів пошуку. Після цього натисніть на кнопку “Пошук”.
									Портал надасть Вам перелік лікарів згідно заданих Вами параметрів пошуку.</p>
							</InstructionItemContent>
							<InstructionItemHeader>
								<div>3</div>
								<h3>Оберіть лікаря</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<p>Оберіть лікаря з наданого переліку. У картці лікаря, яка Вам відкриється, доступна детальна інформація
									про лікаря. Зареєстровані користувачі можуть скористатися сервісами “Записатися до лікаря”, “Поставити оцінку”, “Залишити подяку”, “Залишити скаргу”.</p>
								<img src={docTitle} alt="оберіть лікаря"></img>
							</InstructionItemContent>
						</InstructionItem>

						<InstructionItem>
							<ScrollableAnchor id={'section3'}>
								<h2>3) Як записатися на прийом до лікаря?</h2>
							</ScrollableAnchor>

							<LoginAndRegistration/>
							<OpenDoctorCard/>
							<InstructionItemHeader>
								<div>3</div>
								<h3>Оберіть дату та час прийому</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<p>Натисніть на кнопку
									<img src={recordToView} alt="час та дата прийому"></img>
									та оберіть зручні дату та час прийому:</p>
								<img src={timeToDoc} alt="час прийому"></img>
								<p>Після вибору бажаного часу прийому Ви підтверджуєте свій запит у окремому вікні:</p>
								<img src={confirmRecordToDoc} alt="підтвердіть вибір"></img>
								<p>Якщо все обрано вірно, натисніть на кнопку “Підтвердити”. Якщо ж ні - закрийте це вікно та оберіть інший час.
								</p>
								<span>Після опрацювання Вашого запиту в реєстратурі відповідної медичної установи Ви отримаєте підтвердження у своєму електронному кабінеті на порталі.</span>
							</InstructionItemContent>
						</InstructionItem>

						<InstructionItem>
							<ScrollableAnchor id={'section4'}>
								<h2>4) Як оцінити роботу лікаря?</h2>
							</ScrollableAnchor>

							<LoginAndRegistration/>
							<OpenDoctorCard/>
							<InstructionItemHeader>
								<div>1</div>
								<h3>Оцініть роботу лікаря</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<p>Натисніть на кнопку
									<img src={makeRate} alt="кнопка оцінки"></img>
									та поставте оцінку:</p>
								<img src={makeMark} alt="поставити оцінку"></img>
								<p>Якщо бажаєте, залиште коментар до оцінки та натисніть кнопку “Попередній перегляд”:</p>
								<img src={beforeSendMark} alt="попередній перегляд"></img>
								<p>Якщо щось було введено неправильно - закрийте це вікно. Якщо оцінка виставлена правильно, натисніть на кнопку “Відправити”:</p>
								<img src={publishedRate} alt="відправити"></img>
								<p>Якщо Ви бажаєте ще раз переглянути оцінку в “Кабінеті користувача”, перейдіть за посиланням або
									натисніть на кнопку “До оцінки”. Якщо Ви хочете продовжити роботу з карткою лікаря, натисніть на кнопку “До порталу”.</p>
							</InstructionItemContent>
						</InstructionItem>

						<InstructionItem>
							<ScrollableAnchor id={'section5'}>
								<h2>5) Як залишити подяку лікарю?</h2>
							</ScrollableAnchor>
							<LoginAndRegistration/>
							<OpenDoctorCard/>
							<InstructionItemHeader>
								<div>3</div>
								<h3>Залиште подяку</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<p>Натисніть на кнопку
									<img src={sendThanks} alt="кнопка подяки"></img>, введіть короткий та детальний зміст Вашої подяки:</p>
								<img src={thanksToDoc} alt=""></img>
								<p>Після цього натисніть на кнопку “Попередній перегляд”:</p>
								<img src={thanksReview} alt=""></img>
								<p>Якщо щось було введено неправильно - закрийте це вікно. Якщо все вірно, натисніть на кнопку “Опублікувати”:</p>
								<img src={publishedThanks} alt=""></img>
								<p>Якщо Ви бажаєте ще раз переглянути подяку в “Кабінеті користувача”, перейдіть за посиланням або
									натисніть на кнопку “До подяки”. Якщо ви хочете продовжити роботу з карткою лікаря натисніть
									на кнопку “До порталу”.</p>
								<span>Звертаємо Вашу увагу на те, що всі звернення проходять перевірку на відповідність загальноприйнятим
									нормам етики та моралі, тому опрацьовуються лише після перевірки.
									Переглянути стан Вашого звернення можна в електронному кабінеті.</span>
							</InstructionItemContent>
						</InstructionItem>

						<InstructionItem>
							<ScrollableAnchor id={'section6'}>
								<h2>6) Як залишити скаргу на лікаря?</h2>
							</ScrollableAnchor>

							<LoginAndRegistration/>
							<OpenDoctorCard/>
							<InstructionItemHeader>
								<div>3</div>
								<h3>Залиште скаргу</h3>
							</InstructionItemHeader>
							<InstructionItemContent>
								<p>Натисніть на кнопку
									<img src={abuse} alt=""></img>, введіть короткий та детальний зміст Вашої скарги:</p>
								<img src={abuseToDoc} alt=""></img>
								<p>Після цього натисніть на кнопку “Попередній перегляд”:</p>
								<img src={abuseReview} alt=""></img>
								<p>Якщо щось було введено неправильно - закрийте це вікно. Якщо все вірно, натисніть на кнопку “Опублікувати”:</p>
								<img src={publishedAbuse} alt=""></img>
								<p>Якщо Ви бажаєте ще раз переглянути скаргу в “Кабінеті користувача”, перейдіть за посиланням або натисніть на кнопку “До скарги”.
									Якщо Ви хочете продовжити роботу з карткою лікаря натисніть на кнопку “До порталу”.</p>
								<span>Звертаємо Вашу увагу на те, що всі звернення проходять перевірку на відповідність загальноприйнятим нормам етики та моралі,
									тому опрацьовуються лише після перевірки. Переглянути стан Вашого звернення можна в електронному кабінеті.</span>
							</InstructionItemContent>
						</InstructionItem>

						<ButtonToTop href="#top"><i className="fa fa-long-arrow-up" aria-hidden="true"></i></ButtonToTop>

					</InstructionList>
				</Grid>
			</Wrapper>
		</div>)
	}
}

export default Habitants;



// WEBPACK FOOTER //
// ./src/system/main/habitants/index.js